import { Box, Button, Grid, Typography } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { formatAED } from "../utils/format";

// "Advance Payment" section of the CDN / Proforma "Convert to Invoice" dialog:
// a read-only summary — Grand Total, Advance Paid and Pending. Payments are
// recorded and removed from the list ("Payments" on the row), not here, so
// converting stays a single, simple step. The server applies the advances to
// the invoice automatically on conversion.
export default function ConvertPaymentSummary({ invoiceTotal = 0, advanceApplied = 0, onViewPayments }) {
  const pending = Math.max(0, Math.round((invoiceTotal - advanceApplied) * 100) / 100);
  const tiles = [
    { label: "Grand Total", value: invoiceTotal, color: "text.primary" },
    { label: "Advance Paid", value: advanceApplied, color: "success.main" },
    { label: "Pending", value: pending, color: pending > 0 ? "warning.dark" : "success.main" },
  ];

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        p: 2,
        mb: 2.5,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
        <AccountBalanceWalletIcon fontSize="small" color="primary" />
        <Typography sx={{ fontWeight: 700, fontSize: 15, flex: 1 }}>Advance Payment</Typography>
        {onViewPayments && (
          <Button size="small" startIcon={<VisibilityOutlinedIcon />} onClick={onViewPayments} sx={{ textTransform: "none" }}>
            View payments
          </Button>
        )}
      </Box>

      <Grid container spacing={1.5}>
        {tiles.map((t) => (
          <Grid item xs={4} key={t.label}>
            <Box sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1.5, px: 1.5, py: 1 }}>
              <Typography sx={{ fontSize: 12, color: "text.secondary" }}>{t.label}</Typography>
              <Typography sx={{ fontSize: 15, fontWeight: 700, color: t.color }}>{formatAED(t.value)}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
